export default class MenuToggle {
  constructor(element) {
    let targetSelector = element.getAttribute("data-target");
    let toggleBtnClassName = element.getAttribute("data-toggle-btn");

    let target = element.getElementsByClassName(targetSelector)[0];
    let toggleBtn = element.getElementsByClassName(toggleBtnClassName)[0];

    if (!target || !toggleBtn) {
      return;
    }

    toggleBtn.addEventListener("click", function (e) {
      console.log("click");
      e.preventDefault();
      toggleBtn.setAttribute(
        "aria-expanded",
        String(toggleBtn.getAttribute("aria-expanded") !== "true"),
      );
      target.setAttribute(
        "aria-hidden",
        String(target.getAttribute("aria-hidden") !== "true"),
      );
    });
  }
}
